// @flow
import Journey from "common/records/Journey"

type SetJourney = {|
  type: "SET_JOURNEY",
  payload: Journey,
|}

export type Action = SetJourney

export const setJourney = (journey: Journey): SetJourney => ({
  type: "SET_JOURNEY",
  payload: journey,
})
